import styled from '@emotion/styled';
import colors from '../../../../styling/colors';

export default styled.div`
  display: flex;
  font-size: 1rem;
  flex-basis: 100%;
  align-items: center;
  line-height: 1rem;
  margin: 1rem 0;

  &::after,
  &::before {
    display: flex;
    content: '';
    flex-grow: 1;
    background: ${colors('alto')};
    height: 1px;
    font-size: 0;
    line-height: 0;
  }

  &::before {
    margin-right: 0.5rem;
  }

  &::after {
    margin-left: 0.5rem;
  }
`;
